export default __webpack_public_path__ + "static/article-2-33db55329e2bfb5b9ded7acf1830df45.png";